export default "__VITE_ASSET__ad1879d1__"